var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMercadoLibreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 24,
    cy: 24,
    rx: 19.5,
    ry: 12.978
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.7044,15.5305A20.8345,20.8345,0,0,0,16.09,17.3957a22.8207,22.8207,0,0,0,4.546-.7731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.8824,15.6143a8.6157,8.6157,0,0,1-5.1653,1.4849c-3.3351,0-6.2255-2.1987-9.2148-2.1987-2.6681,0-7.189,4.3727-7.189,5.1633s1.3094,1.26,2.3717.7411c.6215-.3036,3.31-2.9151,5.4843-2.9151s9.2186,7.1361,9.8571,7.8066c.9882,1.0376-.9264,3.2733-2.1493,2.05s-3.4092-3.1621-3.4092-3.1621"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.4,22.6826a23.9981,23.9981,0,0,0-8.5467,2.6926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.5807,27.4555c.9881,1.0376-.9265,3.2733-2.1493,2.05S27.85,26.9933,27.85,26.9933"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.1349,29.2147c.9882,1.0376-.9264,3.2733-2.1493,2.05S25.96,29.3032,25.96,29.3032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.2015,31.3156A2.309,2.309,0,0,0,27.85,31.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.2015,31.3156c.5306-.6964.49-3.1817-2.2437-2.6876.6423-1.2188.0658-3.1457-2.3881-2.0093A1.69,1.69,0,0,0,16.424,25.96a1.4545,1.4545,0,0,0-2.8-.28c-.5435,1.1035.2964,3.0963,2.0916,1.9763-.1812,1.9435.84,2.5364,2.6845,1.7788.0989,1.91,1.367,1.7457,2.2728,1.3011A1.9376,1.9376,0,0,0,24.2015,31.3156Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.6706,22.2785a18.3081,18.3081,0,0,1,9.0635,3.2144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercadoLibreLogo);
export default __webpack_public_path__ + "static/media/mercado-libre-logo.01308c1112cd420973336b79aa0785a1.svg";
export { ForwardRef as ReactComponent };